import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.8px;}" }) }),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 12,
			cy: 9.75,
			r: 5.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M18.913,20.876a9.746,9.746,0,0,0-13.826,0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-1",
			cx: 12,
			cy: 12,
			r: 11.25
		})
	]
});
export default SvgUser;
